/* eslint-disable no-unused-vars */
import { createContext, useContext, ReactNode } from 'react';
import { AnyAction, Dispatch } from 'redux';
import Teachr from '../Objects/models/Teachr';

export interface DeclarationContexteType {
    teachr: Teachr;
    dispatch: Dispatch<AnyAction>;
    generalStep: any;
    step: number;
    handleChangeStep: (val: number) => void;
    // Données clients - gérées dans IndexDeclaration, consommées par FirstStep
    clients: any[];
    totalItems: number;
    currentPage: number;
    nameSearch: string;
    setNameSearch: (val: string) => void;
    paginate: (page: number) => void;
    pageLimit: (limit: number) => void;
}

const DeclarationContexte = createContext<DeclarationContexteType | null>(null);

export const useDeclarationContexte = () => {
    const context = useContext(DeclarationContexte);
    if (!context) {
        throw new Error("useDeclarationContexte doit être utilisé à l'intérieur d'un DeclarationProvider");
    }
    return context;
};

interface DeclarationProviderProps {
    children: ReactNode;
    value: DeclarationContexteType;
}

export const DeclarationProvider = ({ children, value }: DeclarationProviderProps) => {
    return (
        <DeclarationContexte.Provider value={value}>
            {children}
        </DeclarationContexte.Provider>
    );
};
